import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core'

@Component({
  selector: 'fe-question-type',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./question-type.component.scss'],
  template: `
    <mat-icon class="fe-question-type_i">{{icon}}</mat-icon>
    <div class="fe-question-type_body">
      <mat-form-field class="fullwidth form-field-compact">
        <input matInput disabled [placeholder]="text">
      </mat-form-field>
    </div>
  `,
  host: {'class': 'question_answer'}
})
export class QuestionTypeComponent {

  @Input() icon: string

  @Input() text: boolean
}
